module.exports = __webpack_public_path__ + "static/media/dungeon_entrance.106e73df.png";